import React, { useRef, useState, useEffect } from 'react';
import './SectionDivider.css';

const DIVIDER_IMAGES = [
  'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1920&q=80',
  'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1920&q=80',
  'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1920&q=80',
  'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1920&q=80',
  'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=1920&q=80',
];

const SectionDivider = ({ variant = 0 }) => {
  const imageIndex = variant % DIVIDER_IMAGES.length;
  const image = DIVIDER_IMAGES[imageIndex];
  const elRef = useRef(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      if (!elRef.current) return;
      const rect = elRef.current.getBoundingClientRect();
      const centerY = rect.top + rect.height / 2;
      const viewportCenter = window.innerHeight / 2;
      const diff = centerY - viewportCenter;
      setOffset(diff * 0.15);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <div
      ref={elRef}
      className="section-divider"
      style={{
        backgroundImage: `url(${image})`,
        backgroundPositionY: `calc(50% + ${offset}px)`,
      }}
      role="img"
      aria-hidden="true"
    >
      <div className="section-divider-overlay" />
    </div>
  );
};

export default SectionDivider;
